import { all } from 'redux-saga/effects';
import { watchRefresh } from './refreshOnboardingItems';
import { watchVoid } from './voidInvestorOnboardingItem';
import { watchSign } from './signItem';

export default function* rootSaga() {
  yield all([watchRefresh(), watchVoid(), watchSign()]);
}
